<template>
  <div id="banner_content">
    <v-container class="banner">
      <v-row
        class="top-flex-row d-flex flex-row justify-space-between align-center"
      >
        <img
          src="../images/webclip.png"
          loading="lazy"
          alt=""
          class="nav_logo"
        />
        <!-- <v-btn to="/ToDo">ToDo</v-btn> -->
        <!-- button -->
        <v-btn
          href="https://www.governmentjobs.com/careers/reno?keywords=police%20officer"
          target="_blank"
          rel="noopener"
          outlined
          color="gold"
          class="button is-small"
          style="color: white !important"
          >Apply now
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  #banner_content {
    width: 100%;
    position: fixed;
    backdrop-filter: blur(10px);
    z-index: 1;
  }
  .banner {
    background-color: #ba9c58e6;
    height: 68px;
    width: 100%;
    max-width: 100%;
  }

  .container {
    padding: 0 !important;
  }

  .top-flex-row {
    width: 94%;
    margin: 0 auto;
    height: 100%;
  }

  .nav_logo {
    width: 60px;
  }

  // button css
  .button.is-small {
    width: 132px;
    padding: 0.5rem 1.25rem;
    font-size: 1.25rem;
  }
  .button {
    border: 1px solid white;
    background-color: #ba9c58;
    color: #fff !important;
    text-align: center;
    font-family: Oswald;
    text-transform: uppercase;
    padding: 1.5rem 1.5rem !important;
    font-size: 1.75rem;
    font-weight: 600;
    text-decoration: none;
    height: 45px;
  }
  .w-button {
    display: inline-block;
    padding: 9px 15px;
    background-color: #3898ec;
    color: white;
    border: 0;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
    border-radius: 0;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .button.is-small {
    width: 190px;
    font-size: 1.5rem;
  }

  .v-size--default {
    font-size: 0.85rem;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  // #banner_content {
  //   height: 135px;
  // }
}

/* 1440 media q */
@media (min-width: 1440px) {
  .banner {
    height: 88px;
  }
  .button {
    padding: 1.5rem 1.5rem !important;
    height: 51px;
  }

  .nav_logo {
    width: 80px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "banner",
  mixins: [bus_common],
  data() {
    return {
      drawer: false,
      group: null,
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    message2() {
      alert("This button will take the user to the appropriate page.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
